import { hashParamsType } from '@f-fertighaus/applications/UserAccount/interfaces/utils'

const setHashParams = (
  hashParams: hashParamsType & { [key: string]: string }
) => {
  const stringParams = Object.entries(hashParams)
    .map(param => param.join('='))
    .join('&')

  const hashWithParamsInString = `#${stringParams}`

  window.location.hash = hashWithParamsInString
}

const getHashParams = (hash: string) => {
  return Object.fromEntries(
    hash
      .replace('#', '')
      .split(/[&#]/)
      .map(e => e.split('='))
  )
}

export { getHashParams, setHashParams }
